module.exports = __webpack_public_path__ + "static/media/hoyostools.ced558ea.jpeg";